import * as React from 'react';
import AuthContext from '../context/AuthContext';

function StripePricingPage() {
  const context = React.useContext(AuthContext);

  // make sure test environment has test keys, and production env has live keys
  let publicKey;
  let pricingTableId;
  if (process.env.NODE_ENV === 'production') {
    publicKey = "pk_live_51Lma9iDrc8LmsQC1c9hYpaPCRZYVwXPLLXHma3OFs9crt6f99kzWftH61tihmMh7WdpVvF2gX7TL7d03IS07QVlg00uKM06nct";
    pricingTableId = "prctbl_1LuiDMDrc8LmsQC1xfjRerBw";
  } else {
    publicKey = "pk_test_51Lma9iDrc8LmsQC1TdYwyVJCb2BnvQwBPYEY0vTIIcnaBZXfwLGAprjKIyeZW0o5LwKyh2QuRqNPp43sh0OlyXTj00YxRiS3vM";
    pricingTableId = "prctbl_1LmfaMDrc8LmsQC1cQUMqsZa";
  }
  // Paste the stripe-pricing-table snippet in your React component
  
  return (
    <stripe-pricing-table
      pricing-table-id={pricingTableId}
      publishable-key={publicKey}
      customer-email={context.email}
      client-reference-id={context.user_id}
    >
    </stripe-pricing-table>
  );
}

export default StripePricingPage;